export type OnboardingStepCompleteResult = {
  success: boolean
  error?: string
}

export type OnboardingStepNext = () => Promise<OnboardingStepCompleteResult>

export async function runOnboardingStepNext(
  onNext: OnboardingStepNext,
  setError: (message: string | null) => void,
): Promise<boolean> {
  const result = await onNext()
  if (!result.success) {
    setError(result.error || 'Could not continue')
    return false
  }
  return true
}
